import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { HirUserManagementService } from "./hir-user-management.service";
import { RoleConstants } from "./role.constants";
import { NdmsResolverService } from '../../../../shared/core/interfaces/ndmsResolverService';
import { HirAuthApiService } from "./hir-auth.service";

@Injectable()
export class HirAccessService extends NdmsResolverService {
  currentUser: any;

  private _blocked = false;
  private _failures = 0;

  constructor(private hirAuthApiService: HirAuthApiService,
              private hirUserManagementService: HirUserManagementService,
              private router: Router,
              private roleConstants: RoleConstants) {
    super();
  }

  resolve(route) {
    return new Promise<any>(async (resolve, reject) => {
      let setCurrentUserSubscriber = () => {
        this.hirUserManagementService.getCurrentCachedUser().subscribe(currentUser => {
          this.currentUser = currentUser;
          resolve(currentUser);
        });
      };

      let setCurrentUserPromise = () => {
        this.hirUserManagementService.getCurrentCachedUser().toPromise().then(currentUser => {
          if (!currentUser) {
            this.router.navigateByUrl('/');
            console.error("Unauthorized, redirecting back to NDMS home");
            resolve({});
          } else {
            this.currentUser = currentUser;
            resolve(currentUser);
          }
        }).catch(error => {
          this.router.navigateByUrl('/');
          console.error(error);
        });
      };
      
      if (this.hirAuthApiService.getRaw()) {
        if (HirUserManagementService.currentData && HirUserManagementService.currentData.key !== null) {
          setCurrentUserSubscriber();
        } else {
          setCurrentUserPromise();
        }
      } else {
        this.hirAuthApiService.authenticate().subscribe((res)=>{
          if (HirUserManagementService.currentData && HirUserManagementService.currentData.key !== null) {
            setCurrentUserSubscriber();
          } else {
            setCurrentUserPromise();
          }
        });
      }
    });
  }

  isInRole(roleName:string) {
    if (!this._blocked) {
      if ((!this.currentUser || (this.currentUser && this.currentUser.key === null)) && this._failures < 5) {
        this._blocked = true;
        this._failures++;
        this.hirUserManagementService.getCurrentCachedUser().subscribe(currentUser => {
          this.currentUser = currentUser;
          this._blocked = false;
        });
      }
    }

    return (this.currentUser && (this.currentUser.userRoles || []).find(i => i.roleName === roleName));        
  }

  hasPermission(permission:string) {
    if (!this._blocked) {
      if ((!this.currentUser || (this.currentUser && this.currentUser.key === null)) && this._failures < 5) {
        this._blocked = true;
        this._failures++;
        this.hirUserManagementService.getCurrentCachedUser().subscribe(currentUser => {
          this.currentUser = currentUser;
          this._blocked = false;
        });
      }
    }

    return (this.currentUser && (this.currentUser.userPermissions || []).find(i => i === permission));
  }
}
